import React from "react";
import "./sectionLabel.css";

// Shared subsection header for property / details / inspector panels.
// Renders an "eyebrow" label — small, uppercase, bold, muted, underlined —
// that sits below the panel title and above field content, giving a
// consistent visual hierarchy across all property pages in the app.
export default function SectionLabel({ children, className, style }) {
  const cls = className ? `property-section-label ${className}` : "property-section-label";
  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
}
